import React, { useState, useEffect } from "react";
import CategorySidebar from "../components/CategorySidebar";
import ProductGrid from "../components/ProductGrid";

const ProductsPage = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedCategoryName, setSelectedCategoryName] =
    useState("All Products");

  const handleCategorySelect = (id, name) => {
    setSelectedCategoryId(id);
    setSelectedCategoryName(name);
  };

  return (
    <div className="bg-[#f8f6f1]/50 min-h-screen py-10 px-5 md:px-14 mt-32">
      <div className=" mx-auto flex flex-col md:flex-row gap-8">
        {/* Left Sidebar */}
        <div className="w-full md:w-1/4 lg:w-[23%] flex-shrink-0">
          <CategorySidebar
            selectedCategoryId={selectedCategoryId}
            onSelectCategory={handleCategorySelect}
            setDefaultCategory={(id, name) => {
              if (!selectedCategoryId) {
                setSelectedCategoryId(id);
                setSelectedCategoryName(name);
              }
            }}
          />
        </div>

        {/* Right Main Content */}
        <div className="w-full md:w-3/4 lg:w-4/5 flex-col flex">
          <ProductGrid
            categoryId={selectedCategoryId}
            categoryName={selectedCategoryName}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;
